(function () {
  function getMainSectionId(button) {
    var sectionId = button.getAttribute('data-main-section-id');
    if (sectionId) return sectionId;

    var guide = button.closest('.scent-guide');
    if (guide && guide.getAttribute('data-main-section-id')) {
      return guide.getAttribute('data-main-section-id');
    }

    var mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) {
      return mainProduct.id.replace('MainProduct-', '');
    }

    return '';
  }

  function findAccordionDetails(button) {
    var detailsTarget = button.getAttribute('data-details-target');
    if (detailsTarget) {
      var byId = document.getElementById(detailsTarget);
      if (byId) return byId;
    }

    var accordionId = button.getAttribute('data-accordion-id');
    var mainSectionId = getMainSectionId(button);

    if (accordionId && mainSectionId) {
      var exact = document.getElementById('Details-' + accordionId + '-' + mainSectionId);
      if (exact) return exact;
    }

    if (accordionId) {
      var matches = document.querySelectorAll('.product__accordion details');
      for (var i = 0; i < matches.length; i++) {
        if (matches[i].id && matches[i].id.indexOf(accordionId) !== -1) {
          return matches[i];
        }
      }
    }

    return null;
  }

  function openAccordionDetails(details) {
    if (!details) return false;

    details.setAttribute('open', '');
    details.open = true;

    var summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }

    return true;
  }

  function scrollToAccordion(button) {
    var details = findAccordionDetails(button);
    if (!details) return;

    openAccordionDetails(details);

    var scrollTarget = details.closest('.product__accordion') || details;

    window.setTimeout(function () {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }

  function initGuide(guide) {
    if (guide.dataset.scentGuideInit === 'true') return;
    guide.dataset.scentGuideInit = 'true';

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      guide.setAttribute('data-animate', '');

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
        );

        observer.observe(guide);
      } else {
        guide.classList.add('is-visible');
      }
    } else {
      guide.classList.add('is-visible');
    }

    guide.querySelectorAll('[data-scent-accordion]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToAccordion(button);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.scent-guide').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
